import { FC, useState } from 'react';
import Wizard from '@/components/Wizard/Wizard';
import { SuccessPage } from './NavigationCodeSteps/SuccessPage';
import { NavigationCodeName } from './NavigationCodeSteps/NavigationCodeName';
import { useAddNavigationCodes } from '@/services/bundles/bundles.service';
import { useParams } from 'react-router-dom';
import { showToast } from '@/components/Toast/Toast';
import { ToastTypes } from '@/components/Toast/Toast.types';
import { useTranslation } from 'react-i18next';

const CreateNavCode: FC = () => {
  const { t } = useTranslation();
  const { bundleId } = useParams();
  const addNavigationCodesMutation = useAddNavigationCodes(bundleId !== undefined, bundleId!);
  const [codeName, setCodeName] = useState<string>('');
  const [valuesList, setValuesList] = useState<string[]>([]);
  const [showSuccessPage, setShowSuccessPage] = useState(false);

  const handleInputChange = (event: any) => {
    setCodeName(event.target.value);
  };

  const handleInputKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const trimmedValue = codeName.trim();
      if (trimmedValue && !valuesList.includes(trimmedValue)) {
        setValuesList([...valuesList, trimmedValue]);
        setCodeName('');
      }
    }
  };

  const onClose = () => {
    window.location.href = `/bundles/${bundleId}/viewNavCode`;
  };

  const handleSubmit = () => {
    addNavigationCodesMutation.mutateAsync(
      {
        navCode: valuesList,
      },
      {
        onSuccess: () => {
          setShowSuccessPage(true);
        },
        onError: () => {
          showToast({
            label: t('common.bundle.navCodeErrorMsg'),
            id: 'errorCreatingLinkedBundles',
            toastType: ToastTypes.Error,
          });
        },
      },
    );
  };

  return !showSuccessPage ? (
    <Wizard
      data-testid="createNavCode"
      currentStep={0}
      showStepIndicator={false}
      steps={[
        {
          content: (
            <NavigationCodeName
              codeName={codeName}
              valuesList={valuesList}
              handleInputChange={handleInputChange}
              handleInputKeyDown={handleInputKeyDown}
            />
          ),
          title: t('common.bundle.newNCode'),
          description: '',
          onBackClick: onClose,
          onNextClick: handleSubmit,
          nextButtonText: 'Confirm',
          nextButtonDisabled: valuesList.length === 0,
        },
      ]}
      isOpen
      handleClose={onClose}
    />
  ) : (
    <SuccessPage setShowSuccessPage={setShowSuccessPage} />
  );
};

export default CreateNavCode;
